import React, { memo } from 'react';
import { Skeleton, message } from 'antd';
import ScrollLoad from "../../Scroll/ScrollLoadList";
import CommentItem from "../commentItem";

interface ShortsCommentsProps {
  interiorCommentData: any[];
  commentData: { data: any[] };
  cData: any[];
  paging: any;
  loadRef: any;
  onEndReached: () => void;
  handleReplyComment: (re_id: string, val: string, item: any) => void;
}

const ShortsComments: React.FC<ShortsCommentsProps> = ({
  interiorCommentData = [],
  commentData = { data: [] },
  cData = [],
  paging,
  loadRef,
  onEndReached,
  handleReplyComment
}) => {

  return (
    <>
      {interiorCommentData.length > 0 && (
        <section className="mb-40">
          <p className="text-16 text-[#333333] my-30 font-bold">8891留言</p>
          <CommentItem
            data={interiorCommentData}
            dot={true}
            replyComment={handleReplyComment}
          />
        </section>
      )}

      {!!(commentData?.data || []).length && (
        <section>
          <p className="text-16 text-[#333333] my-30 font-bold">YouTube留言</p>
          <ScrollLoad
            onEndReached={onEndReached}
            onEndReachedThreshold={1500}
            data={cData}
            paging={paging}
            loadRef={loadRef}
          >
            {cData.map((v, i) => (
              <CommentItem type="ytb" key={i} data={v} dot={true} />
            ))}
          </ScrollLoad>
        </section>
      )}
    </>
  );
};

export default memo(ShortsComments);
